import * as c from '@Alternatives/Alternatives/Domain/commands-core';
import { AlternativeAttributeValueDTO } from '@Alternatives/Model';
import { MonthYear } from '@common/types';
import VueCqrs from '@cqrs/vue-component-cqrs';
import Component from 'vue-class-component';

@Component
export default class AlternativesCommands extends VueCqrs {

	invokeChangeStatusCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, id: string, alternativeId: number, newStatusId: number)
	{
		const cmd = new c.ChangeStatusCommandV1(userId, workspaceId, projectId, alternativesListId, id, alternativeId, newStatusId);
		this.$command(cmd, id);
	}

	invokeUpdateAlternativeAttributeValueCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, id: string, alternativeId: number, attributeId: number, currValue: string, newValue: string)
	{
		const cmd = new c.UpdateAlternativeAttributeValueCommandV1(userId, workspaceId, projectId, alternativesListId, id, alternativeId, attributeId, currValue, newValue);
		this.$command(cmd, id);
	}


	invokeCreateNoteCommandV1(workspaceId: number, projectId: number, id: string, noteId: string, noteBody: string)
	{
		const cmd = new c.CreateNoteCommandV1(workspaceId, projectId, id, noteId, noteBody);
		this.$command(cmd, noteId); 
	}

	invokeDeleteAttachedDocumentCommandV1(userId: number, workspaceId: number, alternativesListId: number, alternativeId: string, attachmentId: string)
	{
		const cmd = new c.DeleteAttachedDocumentCommandV1(userId, workspaceId, alternativesListId, alternativeId, attachmentId);
		this.$command(cmd, attachmentId); 
	}

	invokeSendEmailCommandV1(userId: number, workspaceId: number, alternativesListId: number, alternativeId: string, subject: string, replyTo: string, to: string[], bodyHtml: string)
	{
		const cmd = new c.SendEmailCommandV1(userId, workspaceId, alternativesListId, alternativeId, subject, replyTo, to, bodyHtml);
		this.$command(cmd, alternativeId); 
	}

	invokeAddAttachedDocumentCommandV1(userId: number, workspaceId: number, alternativesListId: number, alternativeId: string, attachmentId: string, blobId: string)
	{
		const cmd = new c.AddAttachedDocumentCommandV1(userId, workspaceId, alternativesListId, alternativeId, attachmentId, blobId);
		this.$command(cmd, attachmentId); 
	}


	invokeLinkFoundationAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, fAlternativeId: string)
	{
		const cmd = new c.LinkFoundationAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeId, fAlternativeId);
		this.$command(cmd, fAlternativeId);
	}

	invokeUnlinkFoundationAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, fAlternativeId: string)
	{
		const cmd = new c.UnlinkFoundationAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeId, fAlternativeId);
		this.$command(cmd, fAlternativeId);
	}

	invokeLinkDependentAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, dAlternativeId: string)
	{
		const cmd = new c.LinkDependentAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeId, dAlternativeId);
		this.$command(cmd, dAlternativeId);
	}

	invokeUnlinkDependentAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, dAlternativeId: string)
	{
		const cmd = new c.UnlinkDependentAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeId, dAlternativeId);
		this.$command(cmd, dAlternativeId);
	}


	invokeUpdateAlternativeStartDateCommandV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, startDate: MonthYear | null)
	{
		const cmd = new c.UpdateAlternativeStartDateCommandV1(workspaceId, projectId, alternativesListId, alternativeId, startDate);
		this.$command(cmd, alternativeId);
	}

	invokeUpdateAlternativeCommitmentDateCommandV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, commitmentDate: MonthYear | null)
	{
		const cmd = new c.UpdateAlternativeCommitmentDateCommandV1(workspaceId, projectId, alternativesListId, alternativeId, commitmentDate);
		this.$command(cmd, alternativeId);
	}

	invokeCreateAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, formDefinitionId: number, id: string, name: string, desc: string, statusId: number, attributesValues: AlternativeAttributeValueDTO[])
	{
		const cmd = new c.CreateAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, formDefinitionId, id, name, desc, statusId, attributesValues);
		this.$command(cmd, id);
	}

	invokeUpdateAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, formDefinitionId: number, id: string, name: string, desc: string, statusId: number, attributesValues: AlternativeAttributeValueDTO[])
	{
		const cmd = new c.UpdateAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, formDefinitionId, id, name, desc, statusId, attributesValues);
		this.$command(cmd, id);
	}

	invokeDeleteAlternativeCommandV1(userId: number, workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string)
	{
		const cmd = new c.DeleteAlternativeCommandV1(userId, workspaceId, projectId, alternativesListId, alternativeId);
		this.$command(cmd, alternativeId);
	}
}
